import { CANCELLED } from '../utilities/constant_config';
import { formPost } from '../components/ajax';

$(function() {
  const orderCode = $('input[name=orderCode]').val();
  const errorCode = $('input[name=errorCode]').val();
  const successCode = $('input[name=successCode]').val();
  const errorListAttr = $('input[name=errorListAttr]').val();
  const cancelStatus = $('input[name=cancelStatus]').val();
  const notifications = $('.re-order-notification');
  const successNotification = $('.re-order-notification-success');
  const errorNotification = $('.re-order-notification-error');
  let reorderProductAjaxReq = true;

  if (cancelStatus !== undefined && cancelStatus.toLowerCase() === CANCELLED) {
    $('.buttonsDIv').addClass('col-md-12 col-sm-12');
  } else {
    $('.buttonsDIv').addClass('col-md-4 col-sm-4');
  }

  if (successCode) {
    successNotification.removeClass('hidden');
    successNotification[0].innerHTML += successCode;
  }

  if (!successCode && errorListAttr) {
    errorNotification.removeClass('hidden');
    errorNotification[0].innerHTML += errorCode;
  }

  if (errorListAttr && successCode) {
    notifications.each(function(index, element) {
      var id = element.id;
      if (errorListAttr.indexOf(id) !== -1) {
        element.classList.remove('hidden');
        element.innerHTML += errorCode;
      }
    });
  }
  function reorderItems() {
    const $form = $(document).find('#orderDetailsForm');
    const formURL = `${ACC.config.encodedContextPath}${$form.attr('action')}`;
    const formData = `${$form.serialize()}&orderCode=${orderCode}`;

    if (!reorderProductAjaxReq) return false;
    reorderProductAjaxReq = false;
    formPost(formURL, formData)
      .then(() => {
        reorderProductAjaxReq = true;
      })
      .catch(() => {
        reorderProductAjaxReq = true;
      });
  }

  $(document).on('click', '#reorder-button', reorderItems);
});
